import { computed, reactive, ref } from 'vue';

import {
  paymentPurchase,
  paymentSelect,
} from '@/components/payment/helpers/payment-method/payment-method';
import { PromoShowPurchaseSource } from '@/helpers/gtm-triggers/gtm-triggers';
import { isWelcomeTrialPopupAvailable } from '@/pages/payment/components/purchase/components/purchase-promo/components/subscription-promo-trial/helpers/trial-popup/trial-popup';
import { PaymentStateCard, PaymentStatePackagePremium } from '@/pages/payment/store/payment-state';
import { dispatch } from '@/store/store-helper';

type UseSelfArg = {
  source: PromoShowPurchaseSource;
};

export function useSelf(arg: UseSelfArg) {
  // Ref -----------------------------------------------------------------------
  const cardList = ref<PaymentStateCard[]>();
  const isWelcomePopupAvailable = ref(isWelcomeTrialPopupAvailable());

  // Hook ----------------------------------------------------------------------

  // Computed ------------------------------------------------------------------
  const cardDefault = computed(() => {
    return cardList.value?.[0];
  });

  const isProsperiSource = computed(() => {
    return (
      arg.source === 'profile-insufficient-likes' ||
      arg.source === 'search-insufficient-likes' ||
      arg.source === 'chat-send-message' ||
      arg.source === 'my-profile' ||
      arg.source === 'backend'
    );
  });

  // Method --------------------------------------------------------------------
  function setIsWelcomePopupAvailable(value: boolean) {
    isWelcomePopupAvailable.value = value;
  }

  function purchasePkg(pkg: PaymentStatePackagePremium) {
    paymentPurchase({
      pkg,
    });
  }

  function selectPkg(pkg: PaymentStatePackagePremium) {
    paymentSelect({
      pkg,
    });
  }

  async function fetchCardList() {
    cardList.value = await dispatch('actionPaymentListPaymentCards');
  }

  async function init() {
    await fetchCardList();
  }

  return reactive({
    isWelcomePopupAvailable,
    cardDefault,
    isProsperiSource,
    setIsWelcomePopupAvailable,
    purchasePkg,
    selectPkg,
    init,
  });
}
